// extracted by mini-css-extract-plugin
module.exports = {"miniResultWrap":"dqfKn","partyRow":"XEXPa","noData":"zX3S7","partyCol":"KR5IN","partyColCell":"CcE_6","selected":"y01oY","noBrdr":"xt4HI","brdrBtm":"wT94M","contentCenter":"STPJ3"};